<template>
    <div class="avatar-group" :style="{ height: size + 'px' }">
        <avatar v-for="user in users" :user="user" :key="user.id" :size="size" />
    </div>
</template>

<script>
    export default {
        props: {
            users: {
                type: Array,
                required: true
            },
            size: {
                type: Number,
                default: 32,
            }
        }
    }
</script>

<style lang="scss">
    .avatar + .avatar {
        margin-left: -5px;
    }

    .avatar-group .avatar {
        vertical-align: initial;
        overflow: visible;
        .avatar-inner {
            overflow: visible;
        }
    }
</style>